/**
 * Created by jv on 2019-08-21 (11:47).
 */
import LanguageManager from "Sources/services/language-manager";
// const sectorIcons = require.context("!raw-loader!Images/business-model/sector-icons", false, /\.svg$/);
import CONSTANTS from "Sources/config/constants";

const businessModelImages = require.context("Images/business-model", false, /\.(svg|png|j(e)?pg)$/);
const sectorIcons = require.context("Images/business-model/sector-icons", false, /\.svg$/);

let animationDuration = 2000;

let sectorSettings = {
  size: {
    width: 171,
    height: 171
  },

  radius: {
    rx: 15,
    ry: 15
  },

  backgroundColor: "#E9EEF2",
  backgroundColorActive: "#FFFFFF",

  strokeColor: "#B2D4F1",
  strokeColorPreviewActive: "#59B57D",
  strokeColorPreviewInactive: "#BC3837"
};

let powerGridSettings = {
  cabinetSize: {
    width: 68,
    height: 68
  },

  innerWidth: 21,
  outerWidth: 25,

  backgroundColor: "transparent",
  backgroundColorActive: "transparent",
  strokeColor: "#ABBAC7",
  strokeColorActive: "#679CD3",
  strokeColorPreviewActive: "#59B57D",
  strokeColorPreviewInactive: "#BC3837",

  cabinetIcon: businessModelImages("./electricity-big.svg"),
  pylonIcon: businessModelImages("./electricity-pylon.svg"),
  activeIcon: businessModelImages("./electricity-small.svg"),

  pylonSize: {
    width: 35,
    height: 41
  },

  activeIconSize: {
    width: 37,
    height: 37
  }
};

let roadSettings = {
  dividerWidth: 3,
  innerWidth: 31,
  outerWidth: 35,

  backgroundColor: "#E9EEF2",
  backgroundColorActive: "#FFFFFF",

  strokeColor: "#ABBAC7",
  roadColor: "#E9EEF2",
  roadColorActive: "#FFFFFF",

  dividerColor: "#ABBAC7",
  dividerColorActive: "#679CD3",
  dividerColorPreviewActive: "#59B57D",
  dividerColorPreviewInactive: "#BC3837",

  dividerDashArray: [3, 10],
  dividerDashArrayActive: null,

  crossingIcon: businessModelImages("./crossing.svg"),
  activeArrow: businessModelImages("./arrow.svg")
};

let faqSettings = {
  radius: 37,
  backgroundColor: "#ffffff",
  innerStrokeColor: "#000000",
  innerStrokeRadius: 29,
  innerStrokeWidth: 4,

  text: {
    fontFamily: "Rubik", // %TODO: wss ander font ???
    fontSize: 24,
    alignment: "center",
    color: "#000000"
  },

  markedColor: "#57B67D"
};


let sectors = {
  "limited_resources": {
    // Name is function because we don't yet know what the localization will be until we request it
    name: () => LanguageManager.getValueForKey("business_model.sectors.labels.limited_resources"),
    position: {
      x: 125,
      y: 125,
      z: 0
    },
    icon: sectorIcons("./limited_resources_grey.svg"),
    iconActive: sectorIcons("./limited_resources_white.svg")
  },

  "unlimited_resources": {
    name: () => LanguageManager.getValueForKey("business_model.sectors.labels.unlimited_resources"),
    position: {
      x: 125,
      y: 775,
      z: 0
    },
    icon: sectorIcons("./unlimited_resources_grey.svg"),
    iconActive: sectorIcons("./unlimited_resources_white.svg")
  },

  "waste_valorization": {
    position: {
      x: 415,
      y: 175,
      z: 0
    },
    icon: sectorIcons("./factory_grey.svg"),
    iconActive: sectorIcons("./factory_white.svg")
  },

  "company": {
    name: () => LanguageManager.getValueForKey("business_model.sectors.labels.your_company"),
    position: {
      x: 415,
      y: 585,
      z: 0
    },
    icon: sectorIcons("./company_grey.svg"),
    iconActive: sectorIcons("./company_white.svg")
  },

  "recycling_processing": {
    position: {
      x: 620,
      y: 125,
      z: 0
    },
    startsEmpty: true,
    icon: sectorIcons("./plus.svg"),
    iconActive: sectorIcons("./factory2_white.svg")
  },

  "extra_product": {
    position: {
      x: 620,
      y: 700,
      z: 0
    },
    startsEmpty: true,
    icon: sectorIcons("./plus.svg"),
    // TODO get from server
    iconActive: sectorIcons("./company_white.svg")
  },

  "own_channel": {
    name: () => LanguageManager.getValueForKey("business_model.sectors.labels.own_channel"),
    position: {
      x: 850,
      y: 255,
      z: 0
    },
    icon: sectorIcons("./own_channel_grey.svg"),
    iconActive: sectorIcons("./own_channel_white.svg")
  },

  "stores": {
    name: () => LanguageManager.getValueForKey("business_model.sectors.labels.stores"),
    position: {
      x: 805,
      y: 460,
      z: 0
    },
    icon: sectorIcons("./stores_grey.svg"),
    iconActive: sectorIcons("./stores_white.svg")
  },

  "product_service_system": {
    name: () => LanguageManager.getValueForKey("business_model.sectors.labels.product_service_system"),
    position: {
      x: 850,
      y: 660,
      z: 0
    },
    icon: sectorIcons("./product_service_system.svg"),
    iconActive: sectorIcons("./product_service_system.svg")
  },

  "repair_service": {
    name: () => LanguageManager.getValueForKey("business_model.sectors.labels.repair_service"),
    position: {
      x: 1200,
      y: 255,
      z: 0
    },
    icon: sectorIcons("./repair_service_grey.svg"),
    iconActive: sectorIcons("./repair_service_white.svg")
  },

  "users": {
    name: () => LanguageManager.getValueForKey("business_model.sectors.labels.users"),
    position: {
      x: 1200,
      y: 460,
      z: 0
    },
    icon: sectorIcons("./users_grey.svg"),
    iconActive: sectorIcons("./users_white.svg")
  },

  "reusability": {
    position: {
      x: 1115,
      y: 645,
      z: 0
    },
    startsEmpty: true,
    icon: sectorIcons("./plus.svg"),
    iconActive: sectorIcons("./reusability.svg")
  },

  "recycling": {
    name: () => LanguageManager.getValueForKey("business_model.sectors.labels.recycling"),
    position: {
      x: 1440,
      y: 145,
      z: 0
    },
    icon: sectorIcons("./recycling_grey.svg"),
    iconActive: sectorIcons("./recycling_white.svg")
  },

  "collection": {
    name: () => LanguageManager.getValueForKey("business_model.sectors.labels.collection"),
    position: {
      x: 1440,
      y: 460,
      z: 0
    },
    icon: sectorIcons("./collection_grey.svg"),
    iconActive: sectorIcons("./collection_white.svg")
  },

  "composting": {
    name: () => LanguageManager.getValueForKey("business_model.sectors.labels.composting"),
    position: {
      x: 1440,
      y: 790,
      z: 0
    },
    icon: sectorIcons("./composting_grey.svg"),
    iconActive: sectorIcons("./composting_white.svg")
  },

  "waste": {
    name: () => LanguageManager.getValueForKey("business_model.sectors.labels.waste"),
    position: {
      x: 1660,
      y: 460,
      z: 0
    },
    icon: sectorIcons("./waste_grey.svg"),
    iconActive: sectorIcons("./waste_white.svg")
  }
};

let incomeIcon = {
  position: {
    x: sectors["company"].position.x + sectorSettings.size.width,
    y: sectors["company"].position.y,
    originX: "center",
    originY: "center"
  },
  radius: 37,
  backgroundColor: "#ffffff",
  innerStrokeColor: "#FCC753",
  innerStrokeRadius: 29,
  innerStrokeWidth: 4,

  text: {
    fontFamily: "Rubik",
    fontSize: 24,
    alignment: "center",
    color: "#000000"
  },

  themes: {
    "negative": {
      backgroundColor: "#ffffff",
      innerStrokeColor: "#BC3837",
      text: {
        color: "#000000"
      }
    },
    "positive": {
      backgroundColor: "#ffffff",
      innerStrokeColor: "#59B57D",
      text: {
        color: "#000000"
      }
    }
  }
};

let powerCabinets = {
  "power-cabinet-1": {
    position: {
      x: sectors["limited_resources"].position.x + (sectorSettings.size.width / 2),
      y: (sectors["unlimited_resources"].position.y) - ((sectors["unlimited_resources"].position.y - (sectors["limited_resources"].position.y + sectorSettings.size.height)) / 2),
      z: 0
    }
  }
};

let powerLines = [
  {
    key: "power-line-1",
    connects: [
      "limited_resources",
      "power-cabinet-1"
    ],

    intersections: [],

    connections: [
      // limited_resources -> power_cabinet
      {
        start: "limited_resources",
        startType: "sector",

        bidirectional: false,

        startPosition: {
          x: sectors["limited_resources"].position.x + (sectorSettings.size.width / 2),
          y: sectors["limited_resources"].position.y + sectorSettings.size.height
        },

        navigation: [],

        endPosition: {
          x: powerCabinets["power-cabinet-1"].position.x,
          y: powerCabinets["power-cabinet-1"].position.y
        }
      }
    ],

    pylons: [
      {
        x: sectors["limited_resources"].position.x + (sectorSettings.size.width / 2),
        y: (sectors["limited_resources"].position.y + sectorSettings.size.height) + ((powerCabinets["power-cabinet-1"].position.y - (powerGridSettings.cabinetSize.height / 2) - (sectors["limited_resources"].position.y + sectorSettings.size.height)) / 2)
      }
    ],

    activeIcons: [
      {
        x: sectors["limited_resources"].position.x + (sectorSettings.size.width / 2) - (powerGridSettings.outerWidth / 2),
        y: sectors["limited_resources"].position.y + sectorSettings.size.height + 50
      },
      {
        x: sectors["limited_resources"].position.x + (sectorSettings.size.width / 2) + (powerGridSettings.outerWidth / 2),
        y: powerCabinets["power-cabinet-1"].position.y - (powerGridSettings.cabinetSize.height / 2) - 50
      }
    ]
  },
  {
    key: "power-line-2",
    connects: [
      "unlimited_resources",
      "power-cabinet-1"
    ],

    intersections: [],

    connections: [
      // unlimited_resources -> power_cabinet
      {
        start: "unlimited_resources",
        startType: "sector",

        bidirectional: false,

        startPosition: {
          x: sectors["unlimited_resources"].position.x + (sectorSettings.size.width / 2),
          y: sectors["unlimited_resources"].position.y
        },

        navigation: [],

        endPosition: {
          x: powerCabinets["power-cabinet-1"].position.x,
          y: powerCabinets["power-cabinet-1"].position.y
        }
      }
    ],

    pylons: [
      {
        x: sectors["unlimited_resources"].position.x + (sectorSettings.size.width / 2),
        y: sectors["unlimited_resources"].position.y - ((sectors["unlimited_resources"].position.y - powerCabinets["power-cabinet-1"].position.y - (powerGridSettings.cabinetSize.height / 2)) / 2)
      }
    ],

    activeIcons: [
      {
        x: sectors["unlimited_resources"].position.x + (sectorSettings.size.width / 2) - (powerGridSettings.outerWidth / 2),
        y: sectors["unlimited_resources"].position.y - 50
      },
      {
        x: sectors["limited_resources"].position.x + (sectorSettings.size.width / 2) + (powerGridSettings.outerWidth / 2),
        y: powerCabinets["power-cabinet-1"].position.y + (powerGridSettings.cabinetSize.height / 2) + 50
      }
    ]
  },
  {
    key: "power-line-3",
    connects: [
      "power-cabinet-1",
      "company"
    ],

    intersections: [],

    connections: [
      // power-cabinet-1 -> company
      {
        start: "power-cabinet-1",
        startType: "sector",

        bidirectional: false,

        startPosition: {
          x: powerCabinets["power-cabinet-1"].position.x,
          y: powerCabinets["power-cabinet-1"].position.y
        },

        navigation: [
          {
            x: sectors["company"].position.x + (sectorSettings.size.width / 7),
            type: "absolute"
          }
        ],

        endPosition: {
          x: sectors["company"].position.x + (sectorSettings.size.width / 7),
          y: sectors["company"].position.y
        }
      }
    ],

    pylons: [
      {
        x: sectors["company"].position.x + (sectorSettings.size.width / 7),
        y: powerCabinets["power-cabinet-1"].position.y + powerGridSettings.innerWidth
      }
    ],

    activeIcons: [
      {
        x: powerCabinets["power-cabinet-1"].position.x + 80,
        y: powerCabinets["power-cabinet-1"].position.y - (powerGridSettings.outerWidth / 2)
      },
      {
        x: powerCabinets["power-cabinet-1"].position.x + 180,
        y: powerCabinets["power-cabinet-1"].position.y + (powerGridSettings.outerWidth / 2)
      }
    ]
  }
];

let intersections = {
  "road1-int1": {
    road: "road1",
    position: {
      x: 350,
      y: sectors["company"].position.y + (sectorSettings.size.height / 2)
    },
    connectionSides: [
      CONSTANTS.DIRECTIONS.UP,
      CONSTANTS.DIRECTIONS.RIGHT,
      CONSTANTS.DIRECTIONS.DOWN
    ]
  },
  "road1-int2": {
    road: "road1",
    position: {
      x: 350,
      y: sectors["unlimited_resources"].position.y + (sectorSettings.size.height / 2)
    },
    connectionSides: [
      CONSTANTS.DIRECTIONS.UP,
      CONSTANTS.DIRECTIONS.LEFT,
      CONSTANTS.DIRECTIONS.DOWN
    ]
  },

  "road3-int1": {
    road: "road3",
    position: {
      x: sectors["users"].position.x + (sectorSettings.size.width / 4 * 3),
      y: sectors["reusability"].position.y + (sectorSettings.size.height / 3)
    },
    connectionSides: [
      CONSTANTS.DIRECTIONS.UP,
      CONSTANTS.DIRECTIONS.LEFT,
      CONSTANTS.DIRECTIONS.DOWN
    ]
  },

  "road5-int1": {
    position: {
      x: sectors["extra_product"].position.x + (sectorSettings.size.width / 3),
      y: sectors["company"].position.y + (sectorSettings.size.height / 2)
    },
    connectionSides: [
      CONSTANTS.DIRECTIONS.LEFT,
      CONSTANTS.DIRECTIONS.RIGHT,
      CONSTANTS.DIRECTIONS.DOWN
    ]
  },
  "road5-int2": {
    position: {
      x: sectors["extra_product"].position.x + (sectorSettings.size.width / 5 * 4),
      y: sectors["company"].position.y + (sectorSettings.size.height / 2)
    },
    connectionSides: [
      CONSTANTS.DIRECTIONS.UP,
      CONSTANTS.DIRECTIONS.RIGHT,
      CONSTANTS.DIRECTIONS.LEFT
    ]
  },
  "road5-int3": {
    position: {
      x: sectors["extra_product"].position.x + (sectorSettings.size.width / 5 * 4),
      y: sectors["stores"].position.y + (sectorSettings.size.height / 2)
    },
    connectionSides: [
      CONSTANTS.DIRECTIONS.UP,
      CONSTANTS.DIRECTIONS.RIGHT,
      CONSTANTS.DIRECTIONS.DOWN
    ]
  },

  "road6-int1": {
    position: {
      x: sectors["own_channel"].position.x + sectorSettings.size.width + 50,
      y: sectors["stores"].position.y + (sectorSettings.size.height / 2)
    },
    connectionSides: [
      CONSTANTS.DIRECTIONS.UP,
      CONSTANTS.DIRECTIONS.RIGHT,
      CONSTANTS.DIRECTIONS.DOWN,
      CONSTANTS.DIRECTIONS.LEFT
    ]
  }
};

let roads = [
  {
    key: "road1",
    connects: [
      "limited_resources",
      "unlimited_resources",
      "company",
      "composting",

      "road1-int1",
      "road1-int2"
    ],

    connections: [
      // limited_resources -> road1-int1
      {
        start: "limited_resources",
        startType: "sector",
        end: "road1-int1",
        endType: "intersection",

        bidirectional: false,

        startPosition: {
          x: sectors["limited_resources"].position.x + sectorSettings.size.width,
          y: sectors["limited_resources"].position.y + (sectorSettings.size.height / 2)
        },

        navigation: [
          {
            // x/y null = use same value as current position (only for absolute)
            x: intersections["road1-int1"].position.x,
            type: "absolute"
          }
        ],

        endPosition: {
          x: intersections["road1-int1"].position.x,
          y: intersections["road1-int1"].position.y
        },

        arrowGroup: "road1-a1"
      },

      // unlimited_resources -> road1-int2
      {
        start: "unlimited_resources",
        startType: "sector",
        end: "road1-int2",
        endType: "intersection",

        bidirectional: false,

        startPosition: {
          x: sectors["unlimited_resources"].position.x + sectorSettings.size.width,
          y: sectors["unlimited_resources"].position.y + (sectorSettings.size.height / 2)
        },

        navigation: [],

        endPosition: {
          x: intersections["road1-int2"].position.x,
          y: intersections["road1-int2"].position.y
        },

        arrowGroup: "road1-a2"
      },

      // composting -> road1-int2
      {
        start: "composting",
        startType: "sector",
        end: "road1-int2",
        endType: "intersection",

        bidirectional: false,

        startPosition: {
          x: sectors["composting"].position.x,
          y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2)
        },

        navigation: [
          {
            x: -450,
            y: +0
          },
          {
            x: +0,
            y: +50
          },
          {
            x: intersections["road1-int2"].position.x,
            type: "absolute"
          }
        ],

        endPosition: {
          x: intersections["road1-int2"].position.x,
          y: intersections["road1-int2"].position.y
        },

        arrowGroup: "road1-a3"
      },

      // road1-int2 -> road1-int1
      {
        start: "road1-int2",
        startType: "intersection",
        end: "road1-int1",
        endType: "intersection",

        bidirectional: false,

        startPosition: {
          x: intersections["road1-int2"].position.x,
          y: intersections["road1-int2"].position.y
        },

        navigation: [],

        endPosition: {
          x: intersections["road1-int1"].position.x,
          y: intersections["road1-int1"].position.y
        },

        arrowGroup: "road1-a4"
      },

      // road1-int1 -> company
      {
        start: "road1-int1",
        startType: "intersection",
        end: "company",
        endType: "sector",

        bidirectional: false,

        startPosition: {
          x: intersections["road1-int1"].position.x,
          y: intersections["road1-int1"].position.y
        },

        navigation: [],

        endPosition: {
          x: sectors["company"].position.x,
          y: sectors["company"].position.y + (sectorSettings.size.height / 2)
        },

        arrowGroup: "road1-a5"
      }
    ],

    crossings: [
      {
        x: intersections["road1-int1"].position.x,
        y: 375,
        rotation: 0
      },
      {
        x: intersections["road1-int1"].position.x,
        y: 750,
        rotation: 0
      },
      {
        x: 600,
        y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2) + 50,
        rotation: 90
      },
      {
        x: 1175,
        y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2),
        rotation: 90
      }
    ],

    arrows: [
      // road1-a1
      {
        x: sectors["limited_resources"].position.x + sectorSettings.size.width + 20,
        y: sectors["limited_resources"].position.y + (sectorSettings.size.height / 2),
        rotation: 0,
        group: "road1-a1"
      },
      {
        x: intersections["road1-int1"].position.x,
        y: 250,
        rotation: 90,
        group: "road1-a1"
      },
      {
        x: intersections["road1-int1"].position.x,
        y: 350,
        rotation: 90,
        group: "road1-a1"
      },
      {
        x: intersections["road1-int1"].position.x,
        y: 450,
        rotation: 90,
        group: "road1-a1"
      },
      {
        x: intersections["road1-int1"].position.x,
        y: 550,
        rotation: 90,
        group: "road1-a1"
      },

      // road1-a2
      {
        x: 320,
        y: intersections["road1-int2"].position.y,
        rotation: 0,
        group: "road1-a2"
      },

      // road1-a3
      {
        x: 1400,
        y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2),
        rotation: 180,
        group: "road1-a3"
      },
      {
        x: 1275,
        y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2),
        rotation: 180,
        group: "road1-a3"
      },
      {
        x: 1150,
        y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2),
        rotation: 180,
        group: "road1-a3"
      },
      {
        x: 1025,
        y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2),
        rotation: 180,
        group: "road1-a3"
      },
      {
        x: 900,
        y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2) + 50,
        rotation: 180,
        group: "road1-a3"
      },
      {
        x: 800,
        y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2) + 50,
        rotation: 180,
        group: "road1-a3"
      },
      {
        x: 700,
        y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2) + 50,
        rotation: 180,
        group: "road1-a3"
      },
      {
        x: 600,
        y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2) + 50,
        rotation: 180,
        group: "road1-a3"
      },
      {
        x: 500,
        y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2) + 50,
        rotation: 180,
        group: "road1-a3"
      },
      {
        x: 400,
        y: sectors["composting"].position.y + (sectorSettings.size.height / 3 * 2) + 50,
        rotation: 180,
        group: "road1-a3"
      },
      {
        x: intersections["road1-int2"].position.x,
        y: 900,
        rotation: 270,
        group: "road1-a3"
      },

      // road1-a4
      {
        x: intersections["road1-int1"].position.x,
        y: 825,
        rotation: 270,
        group: "road1-a4"
      },
      {
        x: intersections["road1-int1"].position.x,
        y: 725,
        rotation: 270,
        group: "road1-a4"
      },

      // road1-a5
      {
        x: intersections["road1-int1"].position.x + 40,
        y: intersections["road1-int1"].position.y,
        rotation: 0,
        group: "road1-a5"
      }
    ]
  },

  {
    key: "road2",
    connects: [
      "company",
      "waste_valorization"
    ],

    intersections: [],

    connections: [
      // company -> waste_valorization
      {
        start: "company",
        startType: "sector",
        end: "waste_valorization",
        endType: "sector",

        bidirectional: false,

        startPosition: {
          x: sectors["company"].position.x + (sectorSettings.size.width / 5 * 2),
          y: sectors["company"].position.y
        },

        navigation: [],

        endPosition: {
          x: sectors["waste_valorization"].position.x + (sectorSettings.size.width / 5 * 2),
          y: sectors["waste_valorization"].position.y + sectorSettings.size.height
        },

        arrowGroup: "road2-a1"
      }
    ],

    crossings: [
      {
        x: sectors["waste_valorization"].position.x + (sectorSettings.size.width / 5 * 2),
        y: 390,
        rotation: 0
      }
    ],

    arrows: [
      // road2-a1
      {
        x: sectors["company"].position.x + (sectorSettings.size.width / 5 * 2),
        y: 575,
        rotation: 270,
        group: "road2-a1"
      },
      {
        x: sectors["company"].position.x + (sectorSettings.size.width / 5 * 2),
        y: 475,
        rotation: 270,
        group: "road2-a1"
      },
      {
        x: sectors["company"].position.x + (sectorSettings.size.width / 5 * 2),
        y: 375,
        rotation: 270,
        group: "road2-a1"
      }
    ]
  },

  {
    key: "road3",
    connects: [
      "users",
      "reusability",
      "company",

      "road3-int1"
    ],

    connections: [
      // users -> road3-int1
      {
        start: "users",
        startType: "sector",
        end: "road3-int1",
        endType: "intersection",

        bidirectional: false,

        startPosition: {
          x: sectors["users"].position.x + (sectorSettings.size.width / 4 * 3),
          y: sectors["users"].position.y + sectorSettings.size.height
        },

        navigation: [],

        endPosition: {
          x: intersections["road3-int1"].position.x,
          y: intersections["road3-int1"].position.y
        },

        arrowGroup: "road3-a1"
      },

      // road3-int1 -> reusability
      {
        start: "road3-int1",
        startType: "intersection",
        end: "reusability",
        endType: "sector",

        bidirectional: false,

        startPosition: {
          x: intersections["road3-int1"].position.x,
          y: intersections["road3-int1"].position.y
        },

        navigation: [],

        endPosition: {
          x: sectors["reusability"].position.x + sectorSettings.size.width,
          y: sectors["reusability"].position.y + (sectorSettings.size.height / 3)
        },

        arrowGroup: "road3-a2"
      },

      // road3-int1 -> company
      {
        start: "road3-int1",
        startType: "intersection",
        end: "company",
        endType: "sector",

        bidirectional: false,

        startPosition: {
          x: intersections["road3-int1"].position.x,
          y: intersections["road3-int1"].position.y
        },

        navigation: [
          {
            x: +0,
            y: +155
          },
          {
            x: sectors["product_service_system"].position.x + (sectorSettings.size.width / 2),
            type: "absolute"
          },
          {
            x: +0,
            y: +50
          },
          {
            x: sectors["company"].position.x + (sectorSettings.size.width / 3),
            type: "absolute"
          }
        ],

        endPosition: {
          x: sectors["company"].position.x + (sectorSettings.size.width / 3),
          y: sectors["company"].position.y + sectorSettings.size.height
        },

        arrowGroup: "road3-a3"
      }
    ],

    crossings: [
      {
        x: 600,
        y: intersections["road3-int1"].position.y + 155 + 50,
        rotation: 90
      },
      {
        x: 1190,
        y: intersections["road3-int1"].position.y + 155,
        rotation: 90
      }
    ],

    arrows: [
      // road3-a1
      {
        x: sectors["users"].position.x + (sectorSettings.size.width / 4 * 3),
        y: 675,
        rotation: 90,
        group: "road3-a1"
      },

      // road3-a2
      {
        x: 1300,
        y: intersections["road3-int1"].position.y,
        rotation: 180,
        group: "road3-a2"
      },

      // road3-a3
      {
        x: intersections["road3-int1"].position.x,
        y: 775,
        rotation: 90,
        group: "road3-a3"
      },
      {
        x: 1300,
        y: intersections["road3-int1"].position.y + 155,
        rotation: 180,
        group: "road3-a3"
      },
      {
        x: 1200,
        y: intersections["road3-int1"].position.y + 155,
        rotation: 180,
        group: "road3-a3"
      },
      {
        x: 1100,
        y: intersections["road3-int1"].position.y + 155,
        rotation: 180,
        group: "road3-a3"
      },
      {
        x: 1000,
        y: intersections["road3-int1"].position.y + 155,
        rotation: 180,
        group: "road3-a3"
      },
      {
        x: 850,
        y: intersections["road3-int1"].position.y + 205,
        rotation: 180,
        group: "road3-a3"
      },
      {
        x: 750,
        y: intersections["road3-int1"].position.y + 205,
        rotation: 180,
        group: "road3-a3"
      },
      {
        x: 650,
        y: intersections["road3-int1"].position.y + 205,
        rotation: 180,
        group: "road3-a3"
      },
      {
        x: 550,
        y: intersections["road3-int1"].position.y + 205,
        rotation: 180,
        group: "road3-a3"
      },
      {
        x: sectors["company"].position.x + (sectorSettings.size.width / 3),
        y: 825,
        rotation: 270,
        group: "road3-a3"
      }
    ]
  },

  {
    key: "road4",
    connects: [
      "company",
      "extra_product"
    ],

    intersections: [],

    connections: [
      // company -> extra_product
      {
        start: "company",
        startType: "sector",
        end: "extra_product",
        endType: "sector",

        bidirectional: false,

        startPosition: {
          x: sectors["company"].position.x + (sectorSettings.size.width / 3 * 2),
          y: sectors["company"].position.y + sectorSettings.size.height
        },

        navigation: [
          {
            y: sectors["extra_product"].position.y + (sectorSettings.size.height / 2),
            type: "absolute"
          }
        ],

        endPosition: {
          x: sectors["extra_product"].position.x,
          y: sectors["extra_product"].position.y + (sectorSettings.size.height / 2)
        },

        arrowGroup: "road4-a1"
      }
    ],

    crossings: [
      {
        x: 580,
        y: sectors["extra_product"].position.y + (sectorSettings.size.height / 2),
        rotation: 90
      }
    ],

    arrows: [
      // road4-a1
      {
        x: 575,
        y: sectors["extra_product"].position.y + (sectorSettings.size.height / 2),
        rotation: 0,
        group: "road4-a1"
      }
    ]
  },

  {
    key: "road5",
    connects: [
      "company",
      "extra_product",
      "own_channel",
      "stores",
      "product_service_system",

      "road5-int1",
      "road5-int2",
      "road5-int3"
    ],

    connections: [
      // company -> road5-int1
      {
        start: "company",
        startType: "sector",
        end: "road5-int1",
        endType: "intersection",

        bidirectional: false,

        startPosition: {
          x: sectors["company"].position.x + sectorSettings.size.width,
          y: sectors["company"].position.y + (sectorSettings.size.height / 2)
        },

        navigation: [],

        endPosition: {
          x: intersections["road5-int1"].position.x,
          y: intersections["road5-int1"].position.y
        },

        arrowGroup: "road5-a1"
      },

      // extra_product -> road5-int1
      {
        start: "extra_product",
        startType: "sector",
        end: "road5-int1",
        endType: "intersection",

        bidirectional: false,

        startPosition: {
          x: sectors["extra_product"].position.x + (sectorSettings.size.width / 3),
          y: sectors["extra_product"].position.y
        },

        navigation: [],

        endPosition: {
          x: intersections["road5-int1"].position.x,
          y: intersections["road5-int1"].position.y
        }
      },

      // road5-int1 -> road5-int2
      {
        start: "road5-int1",
        startType: "intersection",
        end: "road5-int2",
        endType: "intersection",

        bidirectional: false,

        startPosition: {
          x: intersections["road5-int1"].position.x,
          y: intersections["road5-int1"].position.y
        },

        navigation: [],

        endPosition: {
          x: intersections["road5-int2"].position.x,
          y: intersections["road5-int2"].position.y
        },

        arrowGroup: "road5-a3"
      },

      // road5-int2 -> product_service_system
      {
        start: "road5-int2",
        startType: "intersection",
        end: "product_service_system",
        endType: "sector",

        bidirectional: false,

        startPosition: {
          x: intersections["road5-int2"].position.x,
          y: intersections["road5-int2"].position.y
        },

        navigation: [
          {
            x: +60,
            y: +0
          },
          {
            y: sectors["product_service_system"].position.y + (sectorSettings.size.height / 2),
            type: "absolute"
          }
        ],

        endPosition: {
          x: sectors["product_service_system"].position.x,
          y: sectors["product_service_system"].position.y + (sectorSettings.size.height / 2)
        },

        arrowGroup: "road5-a4"
      },

      // road5-int2 -> road5-int3
      {
        start: "road5-int2",
        startType: "intersection",
        end: "road5-int3",
        endType: "intersection",

        bidirectional: false,

        startPosition: {
          x: intersections["road5-int2"].position.x,
          y: intersections["road5-int2"].position.y
        },

        navigation: [],

        endPosition: {
          x: intersections["road5-int3"].position.x,
          y: intersections["road5-int3"].position.y
        },

        arrowGroup: "road5-a5"
      },

      // road5-int3 -> stores
      {
        start: "road5-int3",
        startType: "intersection",
        end: "stores",
        endType: "sector",

        bidirectional: false,

        startPosition: {
          x: intersections["road5-int3"].position.x,
          y: intersections["road5-int3"].position.y
        },

        navigation: [],

        endPosition: {
          x: sectors["stores"].position.x,
          y: sectors["stores"].position.y + (sectorSettings.size.height / 2)
        },

        arrowGroup: "road5-a6"
      },

      // road5-int3 -> own_channel
      {
        start: "road5-int3",
        startType: "intersection",
        end: "own_channel",
        endType: "sector",

        bidirectional: false,

        startPosition: {
          x: intersections["road5-int3"].position.x,
          y: intersections["road5-int3"].position.y
        },

        navigation: [
          {
            y: sectors["own_channel"].position.y + (sectorSettings.size.height / 2),
            type: "absolute"
          }
        ],

        endPosition: {
          x: sectors["own_channel"].position.x,
          y: sectors["own_channel"].position.y + (sectorSettings.size.height / 2)
        },

        arrowGroup: "road5-a7"
      }
    ],

    crossings: [
      {
        x: 620,
        y: intersections["road5-int1"].position.y,
        rotation: 90
      },
      {
        x: intersections["road5-int2"].position.x + 60,
        y: 710,
        rotation: 0
      },
      {
        x: intersections["road5-int3"].position.x,
        y: 450,
        rotation: 0
      }
    ],

    arrows: [
      // road5-a1
      {
        x: 625,
        y: intersections["road5-int1"].position.y,
        rotation: 0,
        group: "road5-a1"
      },

      // road5-a3
      {
        x: 725,
        y: intersections["road5-int1"].position.y,
        rotation: 0,
        group: "road5-a3"
      },

      // road5-a4
      {
        x: 800,
        y: intersections["road5-int1"].position.y,
        rotation: 0,
        group: "road5-a4"
      },
      {
        x: intersections["road5-int2"].position.x + 60,
        y: 725,
        rotation: 90,
        group: "road5-a4"
      },

      // road5-a5
      {
        x: intersections["road5-int2"].position.x,
        y: 600,
        rotation: 270,
        group: "road5-a5"
      },

      // road5-a6
      {
        x: 785,
        y: intersections["road5-int3"].position.y,
        rotation: 0,
        group: "road5-a6"
      },

      // road5-a7
      {
        x: intersections["road5-int3"].position.x,
        y: 475,
        rotation: 270,
        group: "road5-a7"
      },
      {
        x: intersections["road5-int3"].position.x,
        y: 375,
        rotation: 270,
        group: "road5-a7"
      },
      {
        x: 825,
        y: sectors["own_channel"].position.y + (sectorSettings.size.height / 2),
        rotation: 0,
        group: "road5-a7"
      }
    ]
  },

  {
    key: "road6",
    connects: [
      "own_channel",
      "stores",
      "product_service_system",
      "users",

      "road6-int1"
    ],

    connections: [
      // own_channel -> road6-int1
      {
        start: "own_channel",
        startType: "sector",
        end: "road6-int1",
        endType: "intersection",

        bidirectional: false,

        startPosition: {
          x: sectors["own_channel"].position.x + sectorSettings.size.width,
          y: sectors["own_channel"].position.y + (sectorSettings.size.height / 2)
        },

        navigation: [
          {
            x: intersections["road6-int1"].position.x,
            type: "absolute"
          }
        ],

        endPosition: {
          x: intersections["road6-int1"].position.x,
          y: intersections["road6-int1"].position.y
        },

        arrowGroup: "road6-a1"
      },

      // stores -> road6-int1
      {
        start: "stores",
        startType: "sector",
        end: "road6-int1",
        endType: "intersection",

        bidirectional: false,

        startPosition: {
          x: sectors["stores"].position.x + sectorSettings.size.width,
          y: sectors["stores"].position.y + (sectorSettings.size.height / 2)
        },

        navigation: [],

        endPosition: {
          x: intersections["road6-int1"].position.x,
          y: intersections["road6-int1"].position.y
        },

        arrowGroup: "road6-a2"
      },

      // product_service_system -> road6-int1
      {
        start: "product_service_system",
        startType: "sector",
        end: "road6-int1",
        endType: "intersection",

        bidirectional: false,

        startPosition: {
          x: sectors["product_service_system"].position.x + sectorSettings.size.width,
          y: sectors["product_service_system"].position.y + (sectorSettings.size.height / 2)
        },

        navigation: [
          {
            x: intersections["road6-int1"].position.x,
            type: "absolute"
          }
        ],

        endPosition: {
          x: intersections["road6-int1"].position.x,
          y: intersections["road6-int1"].position.y
        },

        arrowGroup: "road6-a3"
      },

      // road6-int1 -> users
      {
        start: "road6-int1",
        startType: "intersection",
        end: "users",
        endType: "sector",

        bidirectional: false,

        startPosition: {
          x: intersections["road6-int1"].position.x,
          y: intersections["road6-int1"].position.y
        },

        navigation: [],

        endPosition: {
          x: sectors["users"].position.x,
          y: sectors["users"].position.y + (sectorSettings.size.height / 2)
        },

        arrowGroup: "road6-a4"
      }
    ],

    crossings: [
      {
        x: sectors["stores"].position.x + sectorSettings.size.width + 40,
        y: sectors["stores"].position.y + (sectorSettings.size.height / 2),
        rotation: 90
      },
      {
        x: intersections["road6-int1"].position.x,
        y: 625,
        rotation: 0
      }
    ],

    arrows: [
      // road6-a1
      {
        x: intersections["road6-int1"].position.x,
        y: 400,
        rotation: 90,
        group: "road6-a1"
      },
      {
        x: intersections["road6-int1"].position.x,
        y: 500,
        rotation: 90,
        group: "road6-a1"
      },

      // road6-a2
      {
        x: 1010,
        y: intersections["road6-int1"].position.y,
        rotation: 0,
        group: "road6-a2"
      },

      // road6-a3
      {
        x: 1050,
        y: sectors["product_service_system"].position.y + (sectorSettings.size.height / 2),
        rotation: 0,
        group: "road6-a3"
      },
      {
        x: intersections["road6-int1"].position.x,
        y: 700,
        rotation: 270,
        group: "road6-a3"
      },
      {
        x: intersections["road6-int1"].position.x,
        y: 600,
        rotation: 270,
        group: "road6-a3"
      },

      // road6-a4
      {
        x: 1150,
        y: intersections["road6-int1"].position.y,
        rotation: 0,
        group: "road6-a4"
      }
    ]
  },

  {
    key: "road7",
    connects: [
      "reusability",
      "users"
    ],

    intersections: [],

    connections: [
      // reusability -> users
      {
        start: "reusability",
        startType: "sector",
        end: "users",
        endType: "sector",

        bidirectional: false,

        startPosition: {
          x: sectors["reusability"].position.x + (sectorSettings.size.width / 4),
          y: sectors["reusability"].position.y
        },

        navigation: [
          {
            y: sectors["users"].position.y + (sectorSettings.size.height / 5 * 4),
            type: "absolute"
          }
        ],

        endPosition: {
          x: sectors["users"].position.x,
          y: sectors["users"].position.y + (sectorSettings.size.height / 5 * 4)
        },

        arrowGroup: "road7-a1"
      }
    ],

    crossings: [],

    arrows: [
      // road7-a1
      {
        x: sectors["reusability"].position.x + (sectorSettings.size.width / 4),
        y: 625,
        rotation: 270,
        group: "road7-a1"
      }
    ]
  },

  {
    key: "road8",
    connects: [
      "users",
      "repair_service"
    ],

    intersections: [],

    connections: [
      // users -> repair_service
      {
        start: "users",
        startType: "sector",
        end: "repair_service",
        endType: "sector",

        bidirectional: true,

        startPosition: {
          x: sectors["users"].position.x + (sectorSettings.size.width / 2),
          y: sectors["users"].position.y
        },

        navigation: [],

        endPosition: {
          x: sectors["repair_service"].position.x + (sectorSettings.size.width / 2),
          y: sectors["repair_service"].position.y + sectorSettings.size.height
        }
      }
    ],

    crossings: [
      {
        x: sectors["users"].position.x + (sectorSettings.size.width / 2),
        y: sectors["repair_service"].position.y + sectorSettings.size.height + ((sectors["users"].position.y - sectors["repair_service"].position.y - sectorSettings.size.height) / 2),
        rotation: 0
      }
    ]
  },

  {
    key: "road9",
    connects: [
      "users",
      "collection"
    ],

    intersections: [],

    connections: [
      // users -> collection
      {
        start: "users",
        startType: "sector",
        end: "collection",
        endType: "sector",

        bidirectional: true,

        startPosition: {
          x: sectors["users"].position.x + sectorSettings.size.width,
          y: sectors["users"].position.y + (sectorSettings.size.height / 2)
        },

        navigation: [],

        endPosition: {
          x: sectors["collection"].position.x,
          y: sectors["collection"].position.y + (sectorSettings.size.height / 2)
        },

        arrowGroup: "road9-a1"
      }
    ],

    crossings: [],

    arrows: [
      // road9-a1
      {
        x: 1400,
        y: sectors["users"].position.y + (sectorSettings.size.height / 2),
        rotation: 0,
        group: "road9-a1"
      }
    ]
  },

  {
    key: "road10",
    connects: [
      "collection",
      "composting"
    ],

    intersections: [],

    connections: [
      // collection -> composting
      {
        start: "collection",
        startType: "sector",
        end: "composting",
        endType: "sector",

        bidirectional: true,

        startPosition: {
          x: sectors["collection"].position.x + (sectorSettings.size.width / 2),
          y: sectors["collection"].position.y + sectorSettings.size.height
        },

        navigation: [],

        endPosition: {
          x: sectors["composting"].position.x + (sectorSettings.size.width / 2),
          y: sectors["composting"].position.y
        },

        arrowGroup: "road10-a1"
      }
    ],

    crossings: [
      {
        x: sectors["collection"].position.x + (sectorSettings.size.width / 2),
        y: 700,
        rotation: 0
      }
    ],

    arrows: [
      // road10-a1
      {
        x: sectors["collection"].position.x + (sectorSettings.size.width / 2),
        y: 650,
        rotation: 90,
        group: "road10-a1"
      },
      {
        x: sectors["collection"].position.x + (sectorSettings.size.width / 2),
        y: 750,
        rotation: 90,
        group: "road10-a1"
      }
    ]
  },

  {
    key: "road11",
    connects: [
      "collection",
      "waste"
    ],

    intersections: [],

    connections: [
      // collection -> waste
      {
        start: "collection",
        startType: "sector",
        end: "waste",
        endType: "sector",

        bidirectional: true,

        startPosition: {
          x: sectors["collection"].position.x + sectorSettings.size.width,
          y: sectors["collection"].position.y + (sectorSettings.size.height / 2)
        },

        navigation: [],

        endPosition: {
          x: sectors["waste"].position.x,
          y: sectors["waste"].position.y + (sectorSettings.size.height / 2)
        },

        arrowGroup: "road11-a1"
      }
    ],

    crossings: [],

    arrows: [
      // road11-a1
      {
        x: 1630,
        y: sectors["collection"].position.y + (sectorSettings.size.height / 2),
        rotation: 0,
        group: "road11-a1"
      }
    ]
  },

  {
    key: "road12",
    connects: [
      "waste",
      "recycling"
    ],

    intersections: [],

    connections: [
      // waste -> recycling
      {
        start: "waste",
        startType: "sector",
        end: "recycling",
        endType: "sector",

        bidirectional: true,

        startPosition: {
          x: sectors["waste"].position.x + (sectorSettings.size.width / 2),
          y: sectors["waste"].position.y
        },

        navigation: [
          {
            y: sectors["recycling"].position.y + (sectorSettings.size.height / 2),
            type: "absolute"
          }
        ],

        endPosition: {
          x: sectors["recycling"].position.x + sectorSettings.size.width,
          y: sectors["recycling"].position.y + (sectorSettings.size.height / 2)
        },

        arrowGroup: "road12-a1"
      }
    ],

    crossings: [
      {
        x: sectors["waste"].position.x + (sectorSettings.size.width / 2),
        y: 350,
        rotation: 0
      }
    ],

    arrows: [
      // road12-a1
      {
        x: sectors["waste"].position.x + (sectorSettings.size.width / 2),
        y: 400,
        rotation: 270,
        group: "road12-a1"
      },
      {
        x: sectors["waste"].position.x + (sectorSettings.size.width / 2),
        y: 300,
        rotation: 270,
        group: "road12-a1"
      },
      {
        x: 1675,
        y: sectors["recycling"].position.y + (sectorSettings.size.height / 2),
        rotation: 180,
        group: "road12-a1"
      }
    ]
  },

  {
    key: "road13",
    connects: [
      "recycling",
      "recycling_processing"
    ],

    intersections: [],

    connections: [
      // recycling -> recycling_processing
      {
        start: "recycling",
        startType: "sector",
        end: "recycling_processing",
        endType: "sector",

        bidirectional: true,

        startPosition: {
          x: sectors["recycling"].position.x + (sectorSettings.size.width / 2),
          y: sectors["recycling"].position.y
        },

        navigation: [
          {
            x: +0,
            y: -50
          },
          {
            x: sectors["recycling_processing"].position.x + (sectorSettings.size.width / 2),
            type: "absolute"
          }
        ],

        endPosition: {
          x: sectors["recycling_processing"].position.x + (sectorSettings.size.width / 2),
          y: sectors["recycling_processing"].position.y
        },

        arrowGroup: "road13-a1"
      }
    ],

    crossings: [
      {
        x: 1350,
        y: sectors["recycling"].position.y - 50,
        rotation: 90
      },
      {
        x: 850,
        y: sectors["recycling"].position.y - 50,
        rotation: 90
      }
    ],

    arrows: [
      // road13-a1
      {
        x: sectors["recycling"].position.x + (sectorSettings.size.width / 2),
        y: 125,
        rotation: 270,
        group: "road13-a1"
      },
      {
        x: 1450,
        y: sectors["recycling"].position.y - 50,
        rotation: 180,
        group: "road13-a1"
      },
      {
        x: 1325,
        y: sectors["recycling"].position.y - 50,
        rotation: 180,
        group: "road13-a1"
      },
      {
        x: 1200,
        y: sectors["recycling"].position.y - 50,
        rotation: 180,
        group: "road13-a1"
      },
      {
        x: 1075,
        y: sectors["recycling"].position.y - 50,
        rotation: 180,
        group: "road13-a1"
      },
      {
        x: 950,
        y: sectors["recycling"].position.y - 50,
        rotation: 180,
        group: "road13-a1"
      },
      {
        x: 825,
        y: sectors["recycling"].position.y - 50,
        rotation: 180,
        group: "road13-a1"
      }
    ]
  },

  {
    key: "road14",
    connects: [
      "recycling_processing",
      "company"
    ],

    intersections: [],

    connections: [
      // recycling_processing -> company
      {
        start: "recycling_processing",
        startType: "sector",
        end: "company",
        endType: "sector",

        bidirectional: true,

        startPosition: {
          x: sectors["recycling_processing"].position.x + (sectorSettings.size.width / 2),
          y: sectors["recycling_processing"].position.y + sectorSettings.size.height
        },

        navigation: [
          {
            x: +0,
            y: +140
          },
          {
            x: sectors["company"].position.x + (sectorSettings.size.width / 3 * 2),
            type: "absolute"
          }
        ],

        endPosition: {
          x: sectors["company"].position.x + (sectorSettings.size.width / 3 * 2),
          y: sectors["company"].position.y
        },

        arrowGroup: "road14-a1"
      }
    ],

    crossings: [
      {
        x: 625,
        y: sectors["recycling_processing"].position.y + sectorSettings.size.height + 140,
        rotation: 90
      }
    ],

    arrows: [
      // road14-a1
      {
        x: sectors["recycling_processing"].position.x + (sectorSettings.size.width / 2),
        y: 350,
        rotation: 90,
        group: "road14-a1"
      },
      {
        x: 650,
        y: sectors["recycling_processing"].position.y + sectorSettings.size.height + 140,
        rotation: 180,
        group: "road14-a1"
      },
      {
        x: 550,
        y: sectors["recycling_processing"].position.y + sectorSettings.size.height + 140,
        rotation: 180,
        group: "road14-a1"
      },
      {
        x: sectors["company"].position.x + (sectorSettings.size.width / 3 * 2),
        y: 525,
        rotation: 90,
        group: "road14-a1"
      }
    ]
  }
];

// %NOTE: index en waitOn worden momenteel niet gebruikt // %TODO: herwerken zoals actions bij investementActions
let startActions = [
  {
    index: 0,
    targetType: "sector",
    target: "limited_resources",
    action: CONSTANTS.BUSINESS_MODEL_ACTIONS.ACTIVATE,
    waitOn: null
  },
  {
    index: 1,
    targetType: "road",
    target: [
      {
        startPoint: "limited_resources",
        intersections: [
          "road1-int1"
        ],
        endPoint: "company"
      }
    ],
    action: CONSTANTS.BUSINESS_MODEL_ACTIONS.ACTIVATE,
    waitOn: 0
  },
  {
    index: 2,
    targetType: "sector",
    target: "company",
    action: CONSTANTS.BUSINESS_MODEL_ACTIONS.ACTIVATE,
    waitOn: 1
  },
  {
    index: 3,
    targetType: "power-line",
    target: [
      {
        startPoint: "limited_resources",
        endPoint: "power-cabinet-1"
      },
      {
        startPoint: "power-cabinet-1",
        endPoint: "company"
      }
    ],
    action: CONSTANTS.BUSINESS_MODEL_ACTIONS.ACTIVATE,
    waitOn: 1
  },
  {
    index: 4,
    targetType: "road",
    target: [
      {
        startPoint: "company",
        intersections: [
          "road5-int1",
          "road5-int2",
          "road5-int3"
        ],
        endPoint: "stores"
      }
    ],
    action: CONSTANTS.BUSINESS_MODEL_ACTIONS.ACTIVATE,
    waitOn: 2
  },
  {
    index: 5,
    targetType: "sector",
    target: "stores",
    action: CONSTANTS.BUSINESS_MODEL_ACTIONS.ACTIVATE,
    waitOn: 4
  },
  {
    index: 6,
    targetType: "road",
    target: [
      {
        startPoint: "stores",
        intersections: [
          "road6-int1"
        ],
        endPoint: "users"
      }
    ],
    action: CONSTANTS.BUSINESS_MODEL_ACTIONS.ACTIVATE,
    waitOn: 5
  },
  {
    index: 7,
    targetType: "sector",
    target: "users",
    action: CONSTANTS.BUSINESS_MODEL_ACTIONS.ACTIVATE,
    waitOn: 6
  },
  {
    index: 8,
    targetType: "road",
    target: [
      {
        startPoint: "users",
        endPoint: "collection"
      }
    ],
    action: CONSTANTS.BUSINESS_MODEL_ACTIONS.ACTIVATE,
    waitOn: 7
  },
  {
    index: 9,
    targetType: "sector",
    target: "collection",
    action: CONSTANTS.BUSINESS_MODEL_ACTIONS.ACTIVATE,
    waitOn: 8
  },
  {
    index: 10,
    targetType: "road",
    target: [
      {
        startPoint: "collection",
        endPoint: "waste"
      }
    ],
    action: CONSTANTS.BUSINESS_MODEL_ACTIONS.ACTIVATE,
    waitOn: 9
  },
  {
    index: 11,
    targetType: "sector",
    target: "waste",
    action: CONSTANTS.BUSINESS_MODEL_ACTIONS.ACTIVATE,
    waitOn: 9
  }
];

let investmentActions = {
  "biomaterials": {
    actions: [
      {type: "sector", active: true, wait: true, data: {name: "unlimited_resources"}},
      {
        requirement: "renewablematerials",
        type: "icon",
        active: true,
        wait: true,
        data: {name: "unlimited_resources", source: sectorIcons("./unlimited_resources_bio_white.svg")}
      }
    ]
  },

  "extraproduct": {
    actions: [
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "company",
          endPoint: "extra_product"
        }
      },
      {type: "sector", active: true, wait: true, data: {name: "extra_product"}},
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "extra_product",
          endPoint: "road5-int1"
        }
      }
    ]
  },

  "greenenergy": {
    actions: [
      {type: "sector", active: true, wait: true, data: {name: "unlimited_resources"}},
      {
        type: "power-line", active: true, wait: false, data:
          [{
            startPoint: "unlimited_resources",
            endPoint: "power-cabinet-1"
          }]
      },
      {
        type: "power-line", active: false, wait: false, data:
          [{
            startPoint: "limited_resources",
            endPoint: "power-cabinet-1"
          }]
      }
    ]
  },

  "localproduction": {
    actions: [
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "company",
          intersections: [
            "road5-int1",
            "road5-int2"
          ],
          endPoint: "product_service_system"
        }
      },
      {type: "sector", active: true, wait: true, data: {name: "product_service_system"}},
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "product_service_system",
          intersections: [
            "road6-int1"
          ],
          endPoint: "users"
        }
      }
    ]
  },

  "paas": {
    actions: [
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "company",
          intersections: [
            "road5-int1",
            "road5-int2"
          ],
          endPoint: "product_service_system"
        }
      },
      {type: "sector", active: true, wait: true, data: {name: "product_service_system"}},
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "product_service_system",
          intersections: [
            "road6-int1"
          ],
          endPoint: "users"
        }
      }]
  },

  "productredesign": {
    actions: [
      {type: "sector", active: true, wait: true, data: {name: "company"}}
    ]
  },

  "renewablematerials": {
    // TODO - iets met waste dat nie mag gedisabled worden (reststromen inkopen)
    actions: [
      // {requirement: "productredesign", type: "sector", active: false, wait: false, data: {name: "waste"}},
      // {
      //   requirement: "productredesign", type: "road", active: false, wait: false, data: {
      //     startPoint: "collection",
      //     endPoint: "waste"
      //   }
      // },
      {requirement: "productredesign", type: "sector", active: false, wait: false, data: {name: "limited_resources"}},
      {
        requirement: "productredesign", type: "road", active: false, wait: false, data: {
          startPoint: "limited_resources",
          intersections: [
            "road1-int1"
          ],
          endPoint: "company"
        }
      },
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "collection",
          endPoint: "composting"
        }
      },
      {type: "sector", active: true, wait: true, data: {name: "composting"}},
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "composting",
          intersections: [
            "road1-int2",
            "road1-int1"
          ],
          endPoint: "company"
        }
      },
      {type: "sector", active: true, wait: true, data: {name: "unlimited_resources"}},
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "unlimited_resources",
          intersections: [
            "road1-int2",
            "road1-int1"
          ],
          endPoint: "company"
        }
      }
    ]
  },

  "repairservice": {
    actions: [
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "users",
          endPoint: "repair_service"
        }
      },
      {type: "sector", active: true, wait: true, data: {name: "repair_service"}}
    ]
  },

  "residualflows": {
    actions: [
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "waste",
          endPoint: "recycling"
        }
      },
      {type: "sector", active: true, wait: true, data: {name: "recycling"}},
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "recycling",
          endPoint: "recycling_processing"
        }
      },
      {type: "sector", active: true, wait: true, data: {name: "recycling_processing"}},
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "recycling_processing",
          endPoint: "company"
        }
      }
    ]
  },

  "returnprogram": {
    actions: [
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "users",
          intersections: [
            "road3-int1"
          ],
          endPoint: "company"
        }
      }
    ]
  },

  "reuse": {
    actions: [
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "users",
          intersections: [
            "road3-int1"
          ],
          endPoint: "reusability"
        }
      },
      {type: "sector", active: true, wait: true, data: {name: "reusability"}},
      {type: "text", active: true, wait: true, data: {name: "reusability", value: "Herbruik"}},
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "reusability",
          endPoint: "users"
        }
      }
    ]
  },

  // enkel power lines, geen sector active
  "solarpanels": {
    actions: [
      {
        type: "power-line", active: true, wait: false, data: [{
          startPoint: "unlimited_resources",
          endPoint: "power-cabinet-1"
        }]
      },
      {
        type: "power-line", active: true, wait: false, data: [{
          startPoint: "limited_resources",
          endPoint: "power-cabinet-1"
        }]
      }
    ]
  },

  "spareparts": {
    actions: [
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "road5-int3",
          endPoint: "own_channel"
        }
      },
      {type: "sector", active: true, wait: true, data: {name: "own_channel"}},
      {type: "text", active: true, wait: true, data: {name: "reusability", value: "Herbruik"}},
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "own_channel",
          intersections: [
            "road6-int1"
          ],
          endPoint: "users"
        }
      },
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "users",
          intersections: [
            "road3-int1"
          ],
          endPoint: "reusability"
        }
      },
      {type: "sector", active: true, wait: true, data: {name: "reusability"}},
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "reusability",
          endPoint: "users"
        }
      }
    ]
  },

  "subsidy": {
    // No actions
    actions: []
  },

  "wastevalorization": {
    actions: [
      {
        type: "road", active: true, wait: true, data: {
          startPoint: "company",
          endPoint: "waste_valorization"
        }
      },
      {type: "sector", active: true, wait: true, data: {name: "waste_valorization"}}
    ]
  }
};

let faqIcons = [
  {
    key: "faq-limited_resources",
    position: {
      x: sectors["limited_resources"].position.x + sectorSettings.size.width,
      y: sectors["limited_resources"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["limited_resources"]
  },
  {
    key: "faq-unlimited_resources",
    position: {
      x: sectors["unlimited_resources"].position.x + sectorSettings.size.width,
      y: sectors["unlimited_resources"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["unlimited_resources"]
  },
  {
    key: "faq-waste_valorization",
    position: {
      x: sectors["waste_valorization"].position.x + sectorSettings.size.width,
      y: sectors["waste_valorization"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["waste_valorization"]
  },
  {
    key: "faq-company",
    position: {
      x: sectors["company"].position.x + sectorSettings.size.width,
      y: sectors["company"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["company"]
  },
  {
    key: "faq-recycling_processing",
    position: {
      x: sectors["recycling_processing"].position.x + sectorSettings.size.width,
      y: sectors["recycling_processing"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["recycling_processing"]
  },
  {
    key: "faq-extra_product",
    position: {
      x: sectors["extra_product"].position.x + sectorSettings.size.width,
      y: sectors["extra_product"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["extra_product"]
  },
  {
    key: "faq-own_channel",
    position: {
      x: sectors["own_channel"].position.x + sectorSettings.size.width,
      y: sectors["own_channel"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["own_channel"]
  },
  {
    key: "faq-stores",
    position: {
      x: sectors["stores"].position.x + sectorSettings.size.width,
      y: sectors["stores"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["stores"]
  },
  {
    key: "faq-product_service_system",
    position: {
      x: sectors["product_service_system"].position.x + sectorSettings.size.width,
      y: sectors["product_service_system"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["product_service_system"]
  },
  {
    key: "faq-repair_service",
    position: {
      x: sectors["repair_service"].position.x + sectorSettings.size.width,
      y: sectors["repair_service"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["repair_service"]
  },
  {
    key: "faq-users",
    position: {
      x: sectors["users"].position.x + sectorSettings.size.width,
      y: sectors["users"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["users"]
  },
  {
    key: "faq-reusability",
    position: {
      x: sectors["reusability"].position.x + sectorSettings.size.width,
      y: sectors["reusability"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["reusability"]
  },
  {
    key: "faq-recycling",
    position: {
      x: sectors["recycling"].position.x + sectorSettings.size.width,
      y: sectors["recycling"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["recycling"]
  },
  {
    key: "faq-collection",
    position: {
      x: sectors["collection"].position.x + sectorSettings.size.width,
      y: sectors["collection"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["collection"]
  },
  {
    key: "faq-composting",
    position: {
      x: sectors["composting"].position.x + sectorSettings.size.width,
      y: sectors["composting"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["composting"]
  },
  {
    key: "faq-waste",
    position: {
      x: sectors["waste"].position.x + sectorSettings.size.width,
      y: sectors["waste"].position.y,
      originX: "center",
      originY: "center"
    },
    sector: sectors["waste"]
  },
  {
    key: "faq-power_cabinet",
    position: {
      x: powerCabinets["power-cabinet-1"].position.x + powerGridSettings.cabinetSize.width / 2,
      y: powerCabinets["power-cabinet-1"].position.y - powerGridSettings.cabinetSize.height / 2,
      originX: "center",
      originY: "center"
    }
  },
  {
    key: "faq-road1_1",
    position: {
      x: 350,
      y: 350,
      originX: "center",
      originY: "center"
    }
  },
  {
    key: "faq-road1_2",
    position: {
      x: 650,
      y: 950,
      originX: "center",
      originY: "center"
    }
  },
  {
    key: "faq-road6_int1",
    position: {
      x: intersections["road6-int1"].position.x,
      y: intersections["road6-int1"].position.y,
      originX: "center",
      originY: "center"
    }
  },
  {
    key: "faq-road13_1",
    position: {
      x: 1100,
      y: 100,
      originX: "center",
      originY: "center"
    }
  },
  {
    key: "faq-road3_1",
    position: {
      x: 1150,
      y: 860,
      originX: "center",
      originY: "center"
    }
  },
];

let testLayout = {
  // TODO background takes a little long to load, maybe change to image instead of svg?
  background: businessModelImages("./background.svg"),
  // background: businessModelImages("./background.png"),
  backgroundColor: "#f4f7f9",

  size: {
    width: 1920,
    height: 1080
  },

  sectors,
  sectorSettings,

  incomeIcon,

  powerCabinets,
  powerLines,
  powerGridSettings,

  intersections,
  roads,
  roadSettings,

  startActions,
  investmentActions,

  faqIcons,
  faqSettings,

  animationDuration
};

// TODO maybe add actions (ie, which sectors/power lines/roads should be activated/deactivated) when an investment is made
// + test mode to test all investments

export default testLayout;



// WEBPACK FOOTER //
// ./app/js/components/business-model/layouts/default.js